<template>
    <div class="leaderboard" v-if="sortedResults.length > 0">
       <main class="leaderboard__profiles">
          <article class="leaderboard__profile" v-for="(result, index) in sortedResults" :key="result.userId">
             <img
              :src="result.userDetails?.userThumbnail ? assetHost + '/' + result.userDetails?.userThumbnail : '/img/profile_not_found.png'"
              onerror="this.onerror=null; this.src='/img/profile_not_found.png'"
              :alt="result.username"
              class="leaderboard__picture"
             >
             <span class="leaderboard__name">
              <h5 class="mb-0 h6 fw-semibold">
                {{ result.username }}
              </h5>
             </span>
             <span class="leaderboard__value" v-if="result.isSolved">
              {{ result.time }}<span>{{ translatePlaceToMedal(index) }}</span>
             </span>
             <span class="leaderboard__value" v-else>
              DNF
             </span>
          </article>
       </main>
    </div>
 </template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { PropType } from 'vue';
import { CrosswordRaceResults, CrosswordRaceSolve } from '@/models/Crossword';
import { APP_CONFIGS } from '@/main';

@Options({
    props: {
        raceResults: {
          required: true,
          type: Object as PropType<CrosswordRaceResults>
      },
    }
})
export default class FinalRaceResult extends Vue {

  raceResults!: CrosswordRaceResults;

  get sortedResults(): CrosswordRaceSolve[] {
    console.log(this.raceResults);
    return this.raceResults.results
      .filter((result) => !result.isWaiting)
      .filter((result) => !result.isRevealed)
      .sort((a, b) => {
        // Sort by isSolved (solved first)
        if (a.isSolved !== b.isSolved) {
          return a.isSolved ? -1 : 1;
        }

        // For solved players, sort by time in ascending order
        if (a.isSolved && b.isSolved) {
          const timeA = a.time.split(":").map(Number);
          const timeB = b.time.split(":").map(Number);
          const secondsA = timeA[0] * 3600 + timeA[1] * 60 + timeA[2];
          const secondsB = timeB[0] * 3600 + timeB[1] * 60 + timeB[2];
          const timeComparison = secondsA - secondsB;

          if (timeComparison !== 0) {
            return timeComparison;
          }
        }

        // Tie-breaking: Sort by userId alphabetically
        return a.userId.localeCompare(b.userId);
      });
  }

  translatePlaceToMedal(place: number): string {
    switch (place) {
        case 0:
            return "🥇"; // Gold medal
        case 1:
            return "🥈"; // Silver medal
        case 2:
            return "🥉"; // Bronze medal
        default:
            return ""; // No medal for places beyond third
    }
  }

  get assetHost(): string {
      return APP_CONFIGS.api.assetHost;
  }

}
</script>

<style scoped lang="scss">
.leaderboard {
  max-width: 490px;
  width: 100%;
  border-radius: 12px;

  
  &__profiles {
    background-color: #fff;
    border-radius: 12px;
    padding: 15px 15px 20px;
    display: grid;
    row-gap: 8px;
  }
  
  &__profile {
    display: grid;
    grid-template-columns: 1fr 3fr 1fr;
    align-items: center;
    padding: 10px 10px 10px 10px;
    overflow: hidden;
    border-radius: 10px;
    box-shadow: 0 5px 7px -1px rgba(51, 51, 51, 0.23);
    cursor: pointer;
    transition: transform .25s cubic-bezier(.7,.98,.86,.98), box-shadow .25s cubic-bezier(.7,.98,.86,.98);
    background-color: #fff;
    
    &:hover {
      transform: scale(1.2);
      box-shadow: 0 9px 47px 11px rgba(51, 51, 51, 0.18);
    }
  }
  
  &__picture {
    max-width: 100%;
    width: 50px;
    max-width: 50px;
    max-height: 50px;
    border-radius: 50%;
    box-shadow: 0 0 0 10px #ebeef3, 0 0 0 22px #f3f4f6;
  }
  
  &__name {
    margin-left: 12px;
    max-width: 200px;
    word-break: break-word;
  }
  
  &__value {
    font-weight: 600;
    text-align: right;
    font-size: clamp(14px, 2vw, 20px);
    display: flex;
    padding-left: 5px;
    align-items: baseline;
    
    & > span {
      opacity: .8;
      font-weight: 600;
      font-size: 13px;
      margin-left: 3px;
    }
  }
}
.leaderboard {
  box-shadow: 0 0 40px -10px rgba(0, 0, 0, .4);
}
</style>
